import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  obterDadosFamiliaPorPessoa,
  obterDadosFamiliaPorPessoaIdPositiva,
  obterDadosFamiliaPorPessoaRL,
  obterDadosFamiliaPorPessoaRLIdPositiva,
  obterInformacaoPeriodoRetornoCadastramento,
  obterRepresentanteLegal,
} from '../../api/pessoaAPI';
import { RootState } from '../../app/store';
import { authLogout } from '../../auth/authSlice';

export interface ConsultaSimplesState {
  pessoa: any,
  informacaoPeriodoRetornoCadastramento: any;
  familiaSemRegistroCivil:any;
  dadosRL:any;
}

const initialState: ConsultaSimplesState = {
  pessoa: null,
  informacaoPeriodoRetornoCadastramento: null,
  familiaSemRegistroCivil:null,
  dadosRL: null
};

export const getDadosFamilia = createAsyncThunk(
  'consultaSimples/getDadosFamilia',
  async (identificador: number) => {
    return obterDadosFamiliaPorPessoa(identificador);
  }
);
export const getDadosFamiliaIdPositiva = createAsyncThunk(
  'consultaSimples/getDadosFamiliaIdPositiva',
  async (identificador: number) => {
    return obterDadosFamiliaPorPessoaIdPositiva(identificador);
  }
);
export const getDadosFamiliaRL = createAsyncThunk(
  'consultaSimples/getDadosFamiliaRL',
  async (identificador: number) => {
    return obterDadosFamiliaPorPessoaRL(identificador, true);
  }
);
export const getDadosFamiliaRLMembro = createAsyncThunk(
  'consultaSimples/getDadosFamiliaRLMembro',
  async (identificador: number) => {
    return obterDadosFamiliaPorPessoaRL(identificador, false);
  }
);
export const getDadosFamiliaRLIdPositiva = createAsyncThunk(
  'consultaSimples/getDadosFamiliaRLIdPositiva',
  async (identificador: number) => {
    return obterDadosFamiliaPorPessoaRLIdPositiva(identificador, true);
  }
);
export const getDadosFamiliaRLMembroIdPositiva = createAsyncThunk(
  'consultaSimples/getDadosFamiliaRLMembroIdPositiva',
  async (identificador: number) => {
    return obterDadosFamiliaPorPessoaRLIdPositiva(identificador, false);
  }
);

export const getConsultaDadosRepresentanteLegal = createAsyncThunk(
  'consultaSimples/getConsultaDadosRepresentanteLegal',
  async (numeroFamiliar: number) => {
    return obterRepresentanteLegal(numeroFamiliar);
  }
);

export const getInformacaoPeriodoRetornoCadastramento = createAsyncThunk(
  'consultaSimples/getInformacaoPeriodoRetornoCadastramento',
  async (data: any, { dispatch }) => {
    try {
      const response = await obterInformacaoPeriodoRetornoCadastramento(data.identificador);
      return response;
    } catch (e) {
      dispatch(authLogout({ history: data.history }));
      throw e;
    }
  }
);

export const consultaSimplesSlice = createSlice({
  name: 'consultaSimples',
  initialState,
  reducers: {
    limparDadosFamilia: (state) => {
      state.pessoa = initialState.pessoa;
      state.informacaoPeriodoRetornoCadastramento = initialState.informacaoPeriodoRetornoCadastramento;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDadosFamilia.fulfilled, (state, action) => {
        state.pessoa = action.payload;
      })
      .addCase(getDadosFamiliaIdPositiva.fulfilled, (state, action) => {
        state.pessoa = action.payload;
      })
      .addCase(getDadosFamiliaRL.fulfilled, (state, action) => {
        state.pessoa = action.payload;
      })
      .addCase(getDadosFamiliaRLMembro.fulfilled, (state, action) => {
        state.pessoa = action.payload;
      })
      .addCase(getDadosFamiliaRLIdPositiva.fulfilled, (state, action) => {
        state.pessoa = action.payload;
      })
      .addCase(getDadosFamiliaRLMembroIdPositiva.fulfilled, (state, action) => {
        state.pessoa = action.payload;
      });
      builder.addCase(getInformacaoPeriodoRetornoCadastramento.fulfilled, (state, action) => {
        state.informacaoPeriodoRetornoCadastramento = action.payload;
      });
      builder.addCase(getInformacaoPeriodoRetornoCadastramento.rejected, (state, action) => {
        localStorage.setItem(
          'cadunico/getInformacaoPeriodoRetornoCadastramento/responseError',
          action.error.message as string
        );
      });
      builder.addCase(getConsultaDadosRepresentanteLegal.fulfilled, (state, action) => {
        state.dadosRL = action.payload;
      });
  },
});

export const { limparDadosFamilia } = consultaSimplesSlice.actions;

export const selectPessoa = (state: RootState) => state.consultaSimples.pessoa;

export const selectInformacaoPeriodoRetornoCadastramento = (state: RootState) =>
  state.consultaSimples.informacaoPeriodoRetornoCadastramento;

export const selectFamiliaSemRegistroCivil = (state: RootState) =>
  state.consultaSimples.familiaSemRegistroCivil;

export const selectDadosRL = (state: RootState) => state.consultaSimples.dadosRL;

export default consultaSimplesSlice.reducer;

